import { render, staticRenderFns } from "./CollectionRecordAddBottom.vue?vue&type=template&id=12d2cdb8&scoped=true"
import script from "./CollectionRecordAddBottom.vue?vue&type=script&lang=js"
export * from "./CollectionRecordAddBottom.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecordAddBottom.vue?vue&type=style&index=0&id=12d2cdb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2cdb8",
  null
  
)

export default component.exports